import { render } from "./ProgressPhotos.vue?vue&type=template&id=4a454112"
import script from "./ProgressPhotos.vue?vue&type=script&lang=js"
export * from "./ProgressPhotos.vue?vue&type=script&lang=js"

import exportComponent from "/home/farena/workspace/smt/smt_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__